import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useFeatureFlags, useSessionStorage } from 'hooks';
import TopbarBuilder from './TopbarBuilder';
import TopbarPreview from './TopbarPreview';

const Topbar = () => {
  const { previewing, showBanner } = useSelector(state => state.ui);
  const isIframedInSeismic = useSessionStorage('iframedInSeismic');
  const hasUnificationFeatureFlag = useFeatureFlags(
    'readiness-enable-unification',
  );

  const topbarClassName = classNames('JourneyBuilderTopbar', {
    'JourneyBuilderTopbar-editing': !previewing,
    'JourneyBuilderTopbar-editing--showBanner': showBanner && !previewing,
    'JourneyBuilderTopbar--iFrame':
      isIframedInSeismic && hasUnificationFeatureFlag,
  });

  return (
    <div className={topbarClassName}>
      {previewing ? <TopbarPreview /> : <TopbarBuilder />}
    </div>
  );
};

export default Topbar;
